import { Button, Form, Modal, Radio, notification } from "antd";
// import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

import { POST } from "../../../../providers/useAxiosQuery";
import FloatTextArea from "../../../../providers/FloatTextArea";
import notificationErrors from "../../../../providers/notificationErrors";
import validateRules from "../../../../providers/validateRules";

export default function ModalUploadFileStatus(props) {
	const {
		toggleModalFormUploadFileStatus,
		setToggleModalFormUploadFileStatus,
		selectedRowKeys,
		setSelectedRowKeys,
		setDataSource,
		from,
	} = props;

	console.log("ModalUploadFileStatus props: ", props);

	const [form] = Form.useForm();

	const { mutate: mutateGradeFileStatus, isLoading: isLoadingGradeFileStatus } =
		POST(`api/grade_file_status`, [
			"grade_file_list",
			"faculty_load_profile_status_list",
		]);

	const onFinish = (values) => {
		let status = values.status;

		if (from === "grade_file_status_approved") {
			status = "Disapproved";
		}

		let data = {
			status,
			remarks: values.remarks,
			ids: selectedRowKeys,
		};

		mutateGradeFileStatus(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Grade File",
						description: res.message,
					});

					setToggleModalFormUploadFileStatus(false);

					setDataSource((prev) => {
						return prev.filter((item) => !selectedRowKeys.includes(item.id));
					});

					form.resetFields();

					setSelectedRowKeys([]);
				} else {
					notification.error({
						message: "Grade File",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	return (
		<>
			<Modal
				title="Grade File Status"
				open={toggleModalFormUploadFileStatus}
				onCancel={() => {
					setToggleModalFormUploadFileStatus(false);
				}}
				footer={[
					<Button
						className="btn-main-primary outlined"
						key={1}
						onClick={() => {
							setToggleModalFormUploadFileStatus(false);
							form.resetFields();
						}}
						disabled={isLoadingGradeFileStatus}
					>
						CANCEL
					</Button>,
					<Button
						className="btn-main-primary"
						type="primary"
						key={2}
						onClick={() => form.submit()}
						loading={isLoadingGradeFileStatus}
					>
						SUBMIT
					</Button>,
				]}
			>
				<Form form={form} onFinish={onFinish}>
					{from === "grade_file_status_approval" && (
						<Form.Item
							name="status"
							rules={[validateRules.required()]}
							label="Status"
						>
							<Radio.Group>
								<Radio value="Incomplete">Incomplete</Radio>
								<Radio value="Approved">Approved</Radio>
							</Radio.Group>
						</Form.Item>
					)}

					<Form.Item name="remarks">
						<FloatTextArea label="Remarks" placeholder="Remarks" required />
					</Form.Item>
				</Form>

				{/* <RenderCreatePdf dataSource={dataSource} /> */}
			</Modal>
		</>
	);
}

// const RenderCreatePdf = ({ dataSource }) => {
// 	console.log("dataSource: ", dataSource);

// 	if (dataSource && dataSource.length > 0) {
// 		let data = dataSource.map((item) => {
// 			let grade_files = item.grade_files.length > 0 ? item.grade_files[0] : null;
// 			let attachments = grade_files && grade_files.attachments.length ? grade_files.attachments[0] : null;

// 			return <Document
// 			file={attachments ? attachments.pdf_file : null}
// 			onLoadSuccess={onDocumentLoadSuccess}
// 		>
// 			<Page pageNumber={pageNumber} renderTextLayer={false}>
// 				<div
// 					style={{
// 						display: "flex",
// 						alignItems: "center",
// 						gap: 5,
// 						position: "absolute",
// 						right: 40,
// 						bottom: 100,
// 					}}
// 				>
// 					{toggleModalFormUploadFileShow.data.signature_status === 1 && (
// 						<img
// 							src={toggleModalFormUploadFileShow.data.signature}
// 							alt="pdf"
// 							style={{
// 								width: 120,
// 							}}
// 						/>
// 					)}

// 					<div
// 						style={{
// 							fontSize: 10,
// 							width: 60,
// 						}}
// 					>
// 						Date Created <br />
// 						{moment().format("MM/DD/YYYY HH:mm:ss")}
// 					</div>
// 				</div>
// 			</Page>
// 		</Document>
// 		});

// 		return "asdsa";
// 	} else {
// 		return null;
// 	}
// };
